enum RoleCodesEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  EXHIBITOR = 'EXHIBITOR',
}

export default RoleCodesEnum;
